import React from 'react';

const PricingCard = ({ 
  icon, 
  title, 
  price, 
  originalPrice, 
  period, 
  discountText, 
  features, 
  buttonText = "Get Quote",
  isPopular = false 
}) => {
  return (
    <div className={`relative bg-white rounded-lg border-2 p-6 ${isPopular ? 'border-yellow-400 shadow-lg' : 'border-gray-200'} hover:shadow-md transition-shadow duration-300`}>
      {/* Icon */}
      <div className="flex justify-center mb-4">
        <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
          {icon}
        </div>
      </div>

      {/* Title */}
      <h3 className="text-2xl font-bold text-gray-800 text-center mb-4">
        {title}
      </h3>

      {/* Price */}
      <div className="text-center mb-4">
        <div className="text-3xl font-semibold text-gray-900 ">
          {price} 
          <span className="text-xs font-normal text-gray-500 ml-1">{period}</span>
        </div>
            <div className="mb-6">
        <button
            onClick={() => window.open('https://wa.me/917348824242', '_blank')}
        className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-black font-bold mt-5 py-3 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg">
          {buttonText}
        </button>
      </div>

        {originalPrice && (
          <div className="text-3xl font-black text-gray-900 mt-1">
            {originalPrice} 
            <span className="text-base font-semibold ml-1">{period}</span>
          </div>
        )}
        {discountText && (
          <div className="text-xs text-red-600 mt-1">
            {discountText}
          </div>
        )}
      </div>

      {/* Get Quote Button */}
  
      {/* Features List */}
      <div className="space-y-3">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start">
            <div className="w-5 h-5 bg-yellow-400 rounded-full flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
              <svg className="w-3 h-3 text-black" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            </div>
            <span className="text-sm text-gray-700 leading-relaxed">
              {feature}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingCard;